// dependency-graph-ignore-file
import { type Database } from '@databases/model/database';

import { getValueId } from '../utils/collab-utils.ts';

export function deleteEntry(ydb: Database, entryId: string): void {
  ydb.mutate((db) => {
    db.deleteEntry(entryId);

    db.fields.forEach((fieldId: string) => {
      const valueId = getValueId(entryId, fieldId);

      if (valueId in db.commentThreads) {
        db.removeCommentsOnValue(valueId);
      }
    });
  });
}
